import { DataCard } from '@/reports/index';
import { GoldenTag } from '@/reports/shared/DataCard/DataCardTag/DataCardTag';
import { Text, Stack, Box, Card, Button } from '@/theme/components';
import { Icons, styled, CustomIcons } from '@/theme/index';

const bonusDataAreas = [
  'UCC Filings',
  'DEA Licenses',
  'Sporting Permits',
  'Weapon Permits',
  'Aircraft Registration',
  'Business Affiliations',
  'Professional Licenses',
  'Watercraft Registration',
  'Piloting Licenses',
];
const leftAreas = bonusDataAreas.slice(0, 5);
const rightAreas = bonusDataAreas.slice(5);

const StyledDataCard = styled(DataCard)(({ theme }) => ({
  padding: theme.spacing(6.125, 2.5, 2.5),
  alignSelf: 'stretch',
  width: 249,
  [theme.breakpoints.up('xs')]: {
    width: 273,
  },
}));

const FakeReportSection = () => (
  <StyledDataCard
    boxStyles={{
      overflow: 'hidden',
      position: 'absolute',
      top: 22,
      userSelect: 'none',
    }}
  >
    <GoldenTag>
      <Text fontWeight="bold">Premium</Text>
    </GoldenTag>
    <Text
      variant="h3"
      sx={(theme) => ({
        color: theme.palette.primary.main,
        marginBottom: 2.75,
      })}
    >
      Professional License issued in MA
    </Text>
    <Card variant="outlined" sx={{ padding: 2.5 }}>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Icons.ExpandCircleDown
          color="primary"
          sx={{ transform: 'rotate(180deg)', fontSize: '1.25rem' }}
        />
        <Text lineHeight={1}>Show less</Text>
      </Stack>
    </Card>
  </StyledDataCard>
);

interface FreeBonusDataSuccessScreenProps {
  handleClose: () => void;
}

export const FreeBonusDataSuccessScreen: React.FC<
  FreeBonusDataSuccessScreenProps
> = ({ handleClose }) => {
  return (
    <Stack
      spacing={2.5}
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      <Box textAlign="center">
        <Text variant="h1" sx={{ marginBottom: 1 }}>
          Bonus Data Search Complete!
        </Text>
        <Text>
          We searched our most exclusive sources of additional data in the
          following areas:
        </Text>
      </Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 4 }}>
        <Stack spacing={2}>
          {leftAreas.map((area, index) => (
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              key={index}
            >
              <CustomIcons.CheckIcon
                sx={(theme) => ({
                  fontSize: '1rem',
                  color: theme.palette.primary.main,
                })}
              />
              <Text>{area}</Text>
            </Stack>
          ))}
        </Stack>
        <Stack spacing={2}>
          {rightAreas.map((area, index) => (
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              key={index}
            >
              <CustomIcons.CheckIcon
                sx={(theme) => ({
                  fontSize: '1rem',
                  color: theme.palette.primary.main,
                })}
              />
              <Text>{area}</Text>
            </Stack>
          ))}
          <Text fontWeight="bold">...and more!</Text>
        </Stack>
      </Stack>
      <Card
        sx={{ padding: 0, paddingTop: 2.5, width: { xs: 280, sm: 434 } }}
        variant="outlined"
      >
        <Text fontWeight="bold" textAlign="center">
          Look for yellow tag to identify bonus data
        </Text>
        <Box marginX={{ xs: 2, sm: 10 }} position="relative" minHeight={189}>
          <FakeReportSection />
        </Box>
      </Card>
      <Button variant="contained" onClick={handleClose} color="success">
        View updated report
      </Button>
    </Stack>
  );
};
